// Icon set used by report shell — stroke-based SVGs, no emoji.
// Each icon accepts standard SVG props (size via `size`, color via `currentColor`).
import React from 'react'

const base = (paths, size = 14, strokeWidth = 1.8) => (props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {paths}
  </svg>
)

export const Icon = {
  chevron: base(<path d="M9 18l6-6-6-6" />, 14, 2),
  refresh: base(
    <>
      <path d="M3 12a9 9 0 0 1 15.5-6.3L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-15.5 6.3L3 16" />
      <path d="M3 21v-5h5" />
    </>,
    14, 1.8
  ),
  download: base(
    <>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <path d="M7 10l5 5 5-5" />
      <path d="M12 15V3" />
    </>,
    14, 2
  ),
  mail: base(
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </>,
    14, 1.8
  ),
  bell: base(
    <>
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <path d="M10 21a2 2 0 0 0 4 0" />
    </>,
    14, 1.8
  ),
  pin: base(<path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" fill="currentColor" stroke="none" />, 13),
  close: base(<path d="M18 6L6 18M6 6l12 12" />, 14, 2),
}

export default Icon
